// Update URL here after backend ready
const COMMON_URL = `${process.env.REACT_APP_CLOG_SHARED_SERVICE_ORIGIN_URL}`

const SharedServiceApiUrls = {
  GET_CONTAINER_TYPE: `${COMMON_URL}/container-type/get`
  // GET_CONTAINER_TYPE: 'http://localhost:10878/cal-clogs/container-type/get'
}

export default SharedServiceApiUrls